import { useState } from 'react';

import { useNavigate } from 'react-router';

import { Box, Button, Tooltip } from '@mui/material';

import { ConfirmModal } from 'components/modal';
import { DreStatus } from 'pages/financeiro/dre/types';

type DreListLojaColumnProp = {
    id: number;
    vlReceita: string;
    isLoading: boolean;
    dreStatusEnum: DreStatus['dreStatusEnum'];
    error: string;
};

const getDisabled = (dreStatusEnum: DreStatus['dreStatusEnum'], vlReceita: string) =>
    dreStatusEnum !== 'EM_PREENCHIMENTO' && (dreStatusEnum !== 'A_PREENCHER' || !vlReceita);

export function DrePreencherBtn({ id, dreStatusEnum, vlReceita, isLoading, error }: DreListLojaColumnProp) {
    const [openErrorModal, setOpenErrorModal] = useState(false);
    const navigate = useNavigate();

    return (
        <>
            <ConfirmModal open={openErrorModal} setOpen={setOpenErrorModal} showCancel={false} title="Falha" confirmText="Entendi" text={error} />

            <Tooltip title={error ? 'Visualizar falha' : null}>
                <Box sx={{ width: '100%', display: 'flex' }}>
                    <Button
                        size="small"
                        variant="contained"
                        color={error ? 'error' : 'primary'}
                        loading={isLoading}
                        sx={{ px: 1, py: 0, flex: 1 }}
                        disabled={getDisabled(dreStatusEnum, vlReceita)}
                        onClick={() => {
                            if (error) {
                                setOpenErrorModal(true);
                            } else {
                                navigate({
                                    pathname: `form/${id}`,
                                });
                            }
                        }}
                    >
                        {error ? 'Falha' : 'Preencher'}
                    </Button>
                </Box>
            </Tooltip>
        </>
    );
}
